<template>
  <div>
    <b-modal
      id="view-modal"
      size="lg"
      centered
      hide-footer
      hide-header
      class="p-0"
      no-close-on-backdrop
      :visible="showModal"
      @hidden="closemodal()"
    >
      <b-overlay :show="showSpinner" rounded="sm">
        <div class="cs-modal-header">
          <div>Candidate Details</div>
          <div @click="showSpinner ? '' : closemodal()">
            <img
              class="rotate-on-hover"
              src="../../../assets/img/accessconnew/blueCross.svg"
              alt=""
            />
          </div>
        </div>

        <hr v-if="$route.name == 'VendorKanban'" class="m-0" />
        <div v-if="$route.name == 'VendorKanban'" style="height: 100px">
          <div class="d-flex align-items-center justify-content-center mt-3">
            <div class="position-relative d-flex align-items-center">
              <div class="d-flex flex-column align-items-center">
                <img
                  src="../../../assets/img/newvendorflow/activetick.svg"
                  alt=""
                />
              </div>
              <div
                class="vkcanddetails-tab-line d-flex align-items-center"
              ></div>
              <div
                style="top: 35px; left: -15px"
                class="
                  position-absolute
                  d-flex
                  align-items-center
                  justify-content-center
                  flex-column
                "
              >
                <div class="kanban-ac-smalltxt">
                  {{ candidateStatus.addedDate }}
                </div>
                <div class="kanban-ac-asmnttxt">Added</div>
              </div>
            </div>
            <div class="position-relative d-flex align-items-center">
              <div class="d-flex flex-column align-items-center">
                <img
                  v-if="!candidateStatus.shortListedDate"
                  src="../../../assets/img/newvendorflow/natick.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/newvendorflow/activetick.svg"
                  alt=""
                />
              </div>
              <div
                :class="
                  !candidateStatus.interview &&
                  'vkcanddetails-tab-line-inactive'
                "
                class="vkcanddetails-tab-inactive-line"
              ></div>
              <div
                v-if="candidateStatus.shortListedDate"
                style="top: 35px; left: -15px"
                class="
                  position-absolute
                  d-flex
                  align-items-center
                  justify-content-center
                  flex-column
                "
              >
                <div class="kanban-ac-smalltxt">
                  {{ candidateStatus.shortListedDate }}
                </div>
                <div class="kanban-ac-asmnttxt">Pushed</div>
                <div class="kanban-ac-smalltxt">Vendor</div>
              </div>
              <div
                v-else
                style="top: 35px; left: -50px; width: 125px"
                class="
                  position-absolute
                  d-flex
                  align-items-center
                  justify-content-center
                  flex-column
                "
              >
                <div class="kanban-ac-smalltxt">N/A</div>
              </div>
            </div>
            <div class="position-relative d-flex align-items-center">
              <div class="d-flex flex-column align-items-center">
                <img
                  v-if="!candidateStatus.interview"
                  src="../../../assets/img/newvendorflow/natick.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/newvendorflow/activetick.svg"
                  alt=""
                />
              </div>
              <div
                :class="
                  !candidateStatus.finalResult &&
                  'vkcanddetails-tab-line-inactive'
                "
                class="vkcanddetails-tab-line d-flex align-items-center"
              ></div>

              <div
                v-if="candidateStatus.interview"
                style="top: 35px; left: -15px"
                class="
                  position-absolute
                  d-flex
                  align-items-center
                  justify-content-center
                  flex-column
                "
              >
                <div class="kanban-ac-smalltxt">
                  {{ candidateStatus.interview }}
                </div>
                <div class="kanban-ac-asmnttxt">Interview</div>
                <div class="kanban-ac-smalltxt">Recruiter</div>
              </div>
              <div
                v-else
                style="top: 35px; left: -50px; width: 125px"
                class="
                  position-absolute
                  d-flex
                  align-items-center
                  justify-content-center
                  flex-column
                "
              >
                <div class="kanban-ac-smalltxt">N/A</div>
              </div>
            </div>
            <div
              v-if="candidateStatus.finalResult"
              class="position-relative d-flex align-items-center"
            >
              <div class="d-flex flex-column align-items-center">
                <img
                  :src="getRoundSrc(candidateStatus.finalResult.status)"
                  alt=""
                />
              </div>
              <div
                style="top: 35px; left: -50px; width: 125px"
                class="
                  position-absolute
                  d-flex
                  align-items-center
                  justify-content-center
                  flex-column
                "
              >
                <div class="kanban-ac-smalltxt">
                  {{ candidateStatus.finalResult.date }}
                </div>
                <div
                  :style="getTextColor(candidateStatus.finalResult.status)"
                  class="kanban-ac-asmnttxt"
                >
                  {{ candidateStatus.finalResult.description }}
                </div>
              </div>
            </div>
            <div v-else class="position-relative d-flex align-items-center">
              <div class="d-flex flex-column align-items-center">
                <img
                  src="../../../assets/img/newvendorflow/natick.svg"
                  alt=""
                />
              </div>
              <div
                style="top: 35px; left: -50px; width: 125px"
                class="
                  position-absolute
                  d-flex
                  align-items-center
                  justify-content-center
                  flex-column
                "
              >
                <div class="kanban-ac-smalltxt">N/A</div>
              </div>
            </div>
          </div>
        </div>

        <div class="vc-body">
          <div class="tp-basic-black-txt mb-3 pl-3">Basic Info</div>
          <b-row
            v-for="(field, index) in customFieldsArray"
            :key="field.key + index"
            class="mt-3 pl-3 pr-3"
          >
            <template v-if="field.key != 'resume'">
              <b-col cols="4">
                <div
                  class="
                    pff-add-left-main-headings
                    d-flex
                    align-items-baseline
                    h-100
                  "
                >
                  {{ field.label }}
                </div>
              </b-col>
              <b-col cols="8">
                <div
                  class="
                    viewcand-field
                    d-flex
                    align-items-center
                    justify-content-between
                  "
                >
                  <div v-if="checkFieldKeys(field)">-</div>
                  <div
                    style="word-break: keep-all"
                    v-else-if="Object.keys(candidateData).length > 0"
                  >
                    <template v-if="isHtmlContent(field)">
                      <div v-html="checkValuesOfKey(field)"></div>
                    </template>
                    <template v-else>
                      <img
                        v-if="
                          !checkFieldKeys(field) &&
                          field.controlType == 'upload_file'
                        "
                        :src="getFileIcon(field)"
                      />
                      {{ checkValuesOfKey(field) }}
                    </template>
                  </div>
                  <div
                    v-if="
                      !checkFieldKeys(field) &&
                      field.controlType == 'upload_file'
                    "
                    class="pointer"
                  >
                    <img
                      @click="downloadFile(field)"
                      class="ml-2"
                      src="../../../assets/talentpool/tp_download_vc.svg"
                      alt=""
                    />
                  </div>
                </div>
              </b-col>
            </template>
          </b-row>
          <b-row class="mt-3 pl-3 pr-3">
            <b-col cols="4">
              <div
                class="
                  pff-add-left-main-headings
                  d-flex
                  align-items-baseline
                  h-100
                "
              >
                Created On
              </div>
            </b-col>
            <b-col cols="8">
              <div
                class="
                  viewcand-field
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                {{ formattedCreatedAt }}
              </div>
            </b-col>
          </b-row>

          <!-- new design starts from here -->
          <!-- <b-row class="mt-4">
            <b-col>
              <div class="common-onlyBorder-card relativeclass">
                <b-card>
                  <div v-for="ind in 4" :key="ind">
                    <div>
                      <span class="view-cand-head-font mr-2">
                        Mark Phillip
                      </span>
                      <span class="view-cand-subhead-font">
                        (23rd Aug, 2024, 03:09 PM)
                      </span>
                    </div>
                    <div class="view-cand-font">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmo tempor incididunt ut
                    </div>
                    <hr v-if="ind !== 4" />
                  </div>
                  <div class="view-cand-viewAll">
                    <span class="mr-2"> View All </span>
                    <img
                      src="../../../assets/new-icons/down-arrow.svg"
                      alt=""
                    />
                  </div>
                </b-card>
              </div>
            </b-col>
          </b-row> -->

          <!-- <b-row>
            <b-col>
              <div class="pff-modal-heading mt-4">Candidate Job History</div>
            </b-col>
          </b-row> -->

          <!-- <b-row>
            <b-col>
              <div class="common-whiteShadow-card mt-3">
                <b-card>
                  <div>
                    <div
                      class="
                        view-Cand-blue-card
                        d-flex
                        align-items-center
                        w-100
                      "
                    >
                      <div class="w-60">Job Name 1 (DSJE898RHC)</div>
                      <div
                        class="
                          d-flex
                          align-items-center
                          w-40
                          justify-content-end
                        "
                      >
                        <div>
                          <img
                            src="../../../assets/talentpool/download.svg"
                            class="mr-3 pointer"
                            alt=""
                          />
                        </div>
                        <div>
                          <img
                            class="pointer"
                            src="../../../assets/talentpool/blueuparrow.svg"
                            alt=""
                          /> -->

          <!-- <img
                      class="pointer"
                      src="../../../assets/talentpool/bluedownarrow.svg"
                      alt=""
                    /> -->
          <!-- </div>
                      </div>
                    </div>
                    <div class="p-3 w-100">
                      <div class="mt-3" v-for="cand in 10" :key="cand">
                        <div class="d-flex align-items-center w-100">
                          <div style="width: 40px">
                            <img
                              src="../../../assets/new-icons/assessment-icon.svg"
                              alt=""
                            /> -->
          <!-- rest of the icons -->
          <!-- <img
                              src="../../../assets/new-icons/f2f.svg"
                              alt=""
                            />
                            <img
                              src="../../../assets/new-icons/selected.svg"
                              alt=""
                            />
                            <img
                              src="../../../assets/new-icons/position-id.svg"
                              alt=""
                            />
                            <img
                              src="../../../assets/new-icons/attachment.svg"
                              alt=""
                            />
                            <img
                              src="../../../assets/new-icons/issued-offer-letter.svg"
                              alt=""
                            />
                            <img
                              src="../../../assets/new-icons/note.svg"
                              alt=""
                            />
                            <img
                              src="../../../assets/new-icons/ss.svg"
                              alt=""
                            />
                            <img
                              src="../../../assets/new-icons/on-board.svg"
                              alt=""
                            />
                            <img
                              src="../../../assets/new-icons/not-interested.svg"
                              alt=""
                            /> -->
          <!-- </div>
                          <div class="w-90">
                            <div class="d-flex align-items-center w-100">
                              <div class="w-60 view-Cand-round-name-font">
                                Round 1 - Assessment
                              </div>
                              <div
                                class="
                                  vc-blue-txt
                                  d-flex
                                  align-items-center
                                  w-40
                                  justify-content-end
                                  pointer
                                "
                              >
                                <img
                                  v-b-popover.hover.top="'View'"
                                  src="../../../assets/talentpool/blueEye.svg"
                                  alt=""
                                  class="mr-2 pointer"
                                /> -->
          <!-- for download icon -->
          <!-- <img
                            src="../../../assets/talentpool/download.svg"
                            class="mr-2 pointer"
                            alt=""
                          /> -->
          <!-- Feedback Form
                              </div>
                            </div>
                            <div class="mt-1">
                              <div class="d-flex align-items-center w-100">
                                <div class="w-60 view-cand-second-head">
                                  Simplify3x Interview Process
                                </div>
                                <div
                                  class="
                                    view-cand-subhead-font
                                    d-flex
                                    align-items-center
                                    w-40
                                    justify-content-end
                                    pointer
                                  "
                                >
                                  (23rd Aug,24, 03:09 PM)
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center w-100 mt-1">
                          <div style="width: 40px"></div>
                          <div class="view-Cand-remarks-font w-90">
                            Remarks:
                            <span style="font-weight: 600">
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, sed do eiusmo tempor in cididunt ut
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
            </b-col>
          </b-row> -->

          <template v-if="jobHistory.length > 0">
            <div class="pff-modal-heading mt-3">Candidate Job History</div>
            <div
              class="d-flex justify-content-center mb-3"
              v-if="jobHistoryLoading"
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <div
              v-for="job in jobHistory"
              :key="job.jobID"
              class="viewc-card-container mt-3"
            >
              <div
                @click="toggleCollapse(job)"
                :class="
                  job.jobID === selectedJob.jobID
                    ? 'viewc-open-card pointer'
                    : 'viewc-close-card pointer'
                "
              >
                <div class="vc-black-txt w-80 text-truncate">
                  {{ job.title }}
                </div>
                <div class="d-flex align-items-center">
                  <img
                    @click.stop="candidateSummary(job)"
                    class="mr-3 pointer"
                    v-b-tooltip.hover.bottom="'Download Job History'"
                    src="../../../assets/talentpool/download.svg"
                    alt=""
                  />
                  <img
                    v-if="job.jobID === selectedJob.jobID"
                    class="pointer"
                    src="../../../assets/talentpool/blueuparrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    class="pointer"
                    src="../../../assets/talentpool/bluedownarrow.svg"
                    alt=""
                  />
                </div>
              </div>
              <b-collapse
                :id="job.jobID"
                :visible="job.jobID == selectedJob.jobID"
              >
                <div
                  class="d-flex justify-content-center mb-3 mt-3"
                  v-if="particularJobLoading"
                >
                  <b-spinner label="Loading..."></b-spinner>
                </div>
                <div class="vc-collpase-box">
                  <div
                    v-for="round in particularJob.interviewProcess"
                    :key="round.interviewRound"
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      mt-3
                      w-100
                    "
                  >
                    <div class="d-flex align-items-center w-72">
                      <div>
                        <img :src="getRoundImage(round)" alt="" class="mr-2" />
                      </div>
                      <div class="w-90">
                        <div class="vc-grey-txt">
                          Round {{ round.id }} -
                          {{
                            round.type == "f2f" ? "Face to Face" : "Assessment"
                          }}
                        </div>
                        <div class="vc-grey-txt-2 w-90 text-truncate">
                          {{ round.name }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="vs-notinterested width-140 text-left"
                      v-if="round.feedback.length == 0"
                    >
                      No Feedback
                    </div>

                    <!-- <div
                      v-else-if="
                        round.feedback.length == 1 &&
                        round.feedback[0].feedBackForm &&
                            round.feedback[0].feedBackForm.panelFeedbackForm
                      "
                      class="vc-blue-txt width-140 text-left pointer"
                      @click="
                        downloadFeedback(
                          round.feedback[0].feedBackForm.panelFeedbackForm
                        )
                      "
                    >
                      <img
                        class="ml-2"
                        src="../../../assets/talentpool/tp_download_vc.svg"
                        alt=""
                      />
                      Feedback Form
                    </div> -->
                    <div
                      v-else
                      class="vc-blue-txt width-140 text-left pointer"
                      @click="openFeedbackForm(round)"
                    >
                      <template>
                        <img
                          v-b-popover.hover.top="'View'"
                          src="../../../assets/talentpool/blueEye.svg"
                          alt=""
                          class="mr-2 pointer"
                        />Feedback Form<span v-if="round.feedback.length > 1"
                          >&nbsp;:&nbsp;{{ round.feedback.length }}</span
                        >
                      </template>
                    </div>
                  </div>

                  <div
                    class="d-flex align-items-center mt-3"
                    v-if="particularJob.status == 'Selected'"
                  >
                    <div>
                      <img
                        class="mr-2"
                        src="../../../assets/talentpool/selected.svg"
                        alt=""
                      />
                    </div>
                    <div class="vc-grey-txt-2">Selected</div>
                  </div>
                  <div
                    class="d-flex align-items-center mt-3"
                    v-else-if="particularJob.status == 'Not Intrested'"
                  >
                    <div>
                      <img
                        class="mr-2"
                        src="../../../assets/talentpool/notinterested.svg"
                        alt=""
                      />
                    </div>
                    <div class="vc-grey-txt-2">Not Interested</div>
                  </div>
                  <div
                    class="d-flex align-items-center mt-3"
                    v-else-if="particularJob.status == 'On Hold'"
                  >
                    <div>
                      <img
                        class="mr-2"
                        src="../../../assets/talentpool/onhold.svg"
                        alt=""
                      />
                    </div>
                    <div class="vc-grey-txt-2">On-Hold</div>
                  </div>
                  <div
                    class="d-flex align-items-center mt-3"
                    v-else-if="particularJob.status == 'Rejected'"
                  >
                    <div>
                      <img
                        class="mr-2"
                        src="../../../assets/talentpool/rejected.svg"
                        alt=""
                      />
                    </div>
                    <div class="vc-grey-txt-2">Rejected</div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </template>
        </div>

        <div class="d-flex align-items-center">
          <template>
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                w-100
                border-top
                pt-3
                pb-3
                pl-4
                pr-4
                bluebtn
              "
            >
              <div class="d-flex">
                <div
                  v-if="candidateData.resume"
                  class="vc-blue-txt-2 d-flex align-items-center ml-2 pointer"
                  @click="exportResume(candidateData)"
                >
                  <img
                    class="mr-3 pointer"
                    v-b-tooltip.hover.bottom="'Download Resume'"
                    src="../../../assets/talentpool/download.svg"
                    alt=""
                  />
                  Download Resume
                </div>
                <div
                  v-else
                  class="
                    vc-blue-txt-2
                    d-flex
                    align-items-center
                    ml-2
                    disabled-text
                  "
                >
                  <img
                    class="mr-3"
                    src="../../../assets/talentpool/download.svg"
                    alt=""
                  />
                  Download Resume
                </div>
                <!-- Review Documents -->
                <template v-if="selectedCandidate">
                  <div
                    class="div-line ml-3 mr-1"
                    v-if="
                      (selectedCandidate.documentStatus == 4 ||
                        selectedCandidate.documentStatus == 2) &&
                      kanbanLevel == 'H'
                    "
                  ></div>
                  <div
                    v-if="
                      (selectedCandidate.documentStatus == 4 ||
                        selectedCandidate.documentStatus == 2) &&
                      kanbanLevel == 'H'
                    "
                    class="vc-blue-txt-2 d-flex align-items-center ml-2 pointer"
                    @click="
                      $emit('goto-viewodcs', selectedCandidate.candidateID)
                    "
                  >
                    <img
                      height="20"
                      width="20"
                      src="../../../assets/img/newkanban/reviewdocuments.svg"
                      class="mr-2"
                      alt=""
                    />
                    Review Documents
                  </div>
                </template>
              </div>
              <div class="d-flex">
                <b-button @click="closemodal" class="acs-cancelBtn-modal"
                  >Close</b-button
                >
                <b-button
                  v-if="!candidateData.active && showActivate"
                  class="acs-addBtn-modal ml-3 mr-2"
                  @click="activateCand()"
                  ><img
                    class="mr-2"
                    src="../../../assets/talentpool/activate.svg"
                    alt=""
                  />
                  Activate</b-button
                >
              </div>
            </div>
          </template>
        </div>
      </b-overlay>
    </b-modal>
    <viewMultipleFeedbackVue
      v-if="showFeedbackModal"
      :showModal="showFeedbackModal"
      :feedbacks="selecetdFeedbacks"
      :candidateData="candidateData"
      @closeViewIcon="closeFeedbackModal"
      @download-feedback="downloadFeedback"
    />
    <PreviewFeedback
      v-if="singleFeedbackModal"
      :candidateData="candidateData"
      :selectedRound="singleFeedbackData.feedBackForm.customFeedback"
      :allData="singleFeedbackData"
      :basicCandInfo="singleBasicInfo"
      :ipmodal="singleFeedbackModal"
      :showScreenshot="true"
      @closeModal="closeSingleFeedbackModal"
    />
  </div>
</template>
<script>
import { exportResume } from "../asynchronous";
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
  fileType,
} from "../../../utils/customFields";
import {
  getCandidateJobHistory,
  getCandidateSummary,
  downloadAnyFile,
  getTalentPoolCandidate,
  getcandidateVendorJd,
} from "../../../utils/apiFunctions";
import viewMultipleFeedbackVue from "./viewMultipleFeedback.vue";
import PreviewFeedback from "../../../views/InterviewProcess/PreviewFeedback.vue";

export default {
  name: "ViewCandidate",
  data() {
    return {
      isHoveringDownload: false,
      isHoveringNote: false,

      phonenumberalt: "my name is ramon ridwan of ur office building",
      loopvar: 8,
      loopvar2: 3,
      vccollapse: false,
      showSpinner: false,
      showFeedbackModal: false,
      singleFeedbackModal: false,
      jobHistoryLoading: true,
      particularJobLoading: false,
      jobHistory: [],
      selectedJob: {},
      singleBasicInfo: {},
      candidateData: {},
      particularJob: [],
      selecetdFeedbacks: [],
      candidateStatus: {},
    };
  },
  props: {
    showActivate: Boolean,
    showModal: Boolean,
    candidateID: String,
    selectedCandidate: Object,
    customFieldsArray: Array,
    kanbanLevel: String,
    shared: Boolean,
  },
  components: {
    viewMultipleFeedbackVue,
    PreviewFeedback,
  },
  computed: {
    formattedCreatedAt() {
      const createdAt = this.candidateData.createdAt.substring(0, 10);
      return this.convertDateToDDMMYYYY(createdAt);
    },
    getDocsRejRec() {
      if (
        this.$route.name != "VendorKanban" &&
        this.selectedCandidate.documentStatus != null
      ) {
        if (
          this.selectedCandidate.customerID[this.$route.query.customerID][
            this.$route.query.jobID
          ].documentRejectedByRecruiter != null
        ) {
          return this.selectedCandidate.customerID[
            this.$route.query.customerID
          ][this.$route.query.jobID].documentRejectedByRecruiter;
        }
      }
      return false;
    },
  },
  created() {
    this.showSpinner = true;

    this.getCandidateData();
    if (this.$route.name == "VendorKanban") {
      this.getCandidateStatusDetails();
    }
  },

  methods: {
    convertDateToDDMMYYYY(date) {
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    getFileIcon(field) {
      let filename = this.checkValuesOfKey(field);

      let lastIndexImage = filename.lastIndexOf("/");
      let someImage = filename.substring(lastIndexImage + 1);
      let imagename = someImage.split("?")[0];
      const fileExtension = imagename.split(".").pop().toLowerCase();
      return fileType(fileExtension);
    },
    getTextColor(status) {
      let style;
      switch (status) {
        case 1:
          style = "color : #038E00";
          break;
        case 2:
          style = "color : #424273";
          break;
        case 3:
          style = "color : #EB0002";
          break;
        case 4:
          style = "color : #FFC145";
          break;
        default:
          style = "";
      }
      return style;
    },
    getRoundSrc(status) {
      let src;
      switch (status) {
        case 1:
          src = require("../../../assets/img/newvendorflow/selectedtick.svg");
          break;
        case 2:
          src = require("../../../assets/img/newvendorflow/nitick.svg");
          break;
        case 3:
          src = require("../../../assets/img/newvendorflow/rejectedtick.svg");
          break;
        case 4:
          src = require("../../../assets/img/newvendorflow/onholdtick.svg");
          break;
        default:
          src = "";
      }
      return src;
    },
    async getCandidateData() {
      const res = await getTalentPoolCandidate("2", this.candidateID);
      if (res.status == 200) {
        this.candidateData = res.data.data[0];
        this.candidateJobHistory();
      }
    },
    downloadFeedback(link) {
      const candidateName = this.candidateData.name;
      const fileName = `${candidateName}.pdf`;
      const a = document.createElement("a");
      a.href = link;
      a.download = fileName;
      a.click();
    },
    activateCand() {
      this.$router.push({
        name: "ActivateCandidate",
        params: {
          candidateID: this.candidateData.candidateID,
        },
        query: {
          active: "" + this.candidateData.active,
        },
      });
    },
    async exportResume() {
      await exportResume(this.candidateData);
    },
    async candidateSummary(data) {
      let payload = {
        emailID: this.candidateData.email,
        jobID: data.jobID,
      };
      const res = await getCandidateSummary(payload);
      if (res.status === 200) {
        // create file link in browser's memory
        const href = URL.createObjectURL(res.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", `${this.candidateData.name}.pdf`);

        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      }
    },
    async downloadFile(field) {
      let payload;
      if (field.fieldType != "default") {
        payload = this.candidateData.customFields[field.key];
      } else {
        payload = this.candidateData[field.key];
      }
      const res = await downloadAnyFile(payload);
      if (res.status == 200) {
        const link = res.data.data.downloadLink;
        // implemented bcz once we click on download resume that page shouldn't go blank
        const candidateName = res.data.data.name;

        // Create a dynamic file name based on the candidate's name and email
        const fileName = `${candidateName}_${field.label}.pdf`;

        // Create an anchor element
        const a = document.createElement("a");
        a.href = link;
        a.download = fileName; // Set the dynamically generated file name

        // Trigger a click event on the anchor element
        a.click();
        // this.successModal("Resume downloaded successfully");
      }
    },
    closemodal() {
      this.$emit("closeViewIcon");
    },
    closeFeedbackModal() {
      this.showFeedbackModal = false;
    },
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.candidateData);
    },
    isHtmlContent(field) {
      return isHtmlContent(field, this.candidateData);
    },
    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.candidateData);
    },
    async candidateJobHistory() {
      try {
        const res = await getCandidateJobHistory({
          candidateID: this.candidateData.candidateID,
        });
        if (res.status == 200) {
          this.showSpinner = false;
          this.jobHistory = res.data.data[0].jobInfo;

          // this.selectedJob=this.jobHistory[0]
        }
        this.jobHistoryLoading = false;
      } catch (err) {
        console.error(err);
        this.showSpinner = false;
      }
    },
    async particularJobHistory() {
      this.particularJob = [];
      this.particularJobLoading = true;
      let payload = {
        candidateID: this.candidateData.candidateID,
        jobID: this.selectedJob.jobID,
        type: "2",
        customerID: this.selectedJob.customerID,
      };
      const res = await getCandidateJobHistory(payload);
      if (res.status === 200) {
        this.particularJob = res.data.data;
      }
      this.particularJobLoading = false;
    },
    toggleCollapse(job) {
      if (this.selectedJob.jobID === job.jobID) {
        this.selectedJob = {};
      } else {
        this.selectedJob = job;
        this.particularJobHistory();
      }
    },

    closeSingleFeedbackModal() {
      this.singleFeedbackModal = false;
    },
    openFeedbackForm(round) {
      if (round.feedback.length > 1) {
        this.showFeedbackModal = true;
        this.selecetdFeedbacks = round.feedback;
      } else {
        this.singleFeedbackModal = true;
        this.singleFeedbackData = round.feedback[0];
        this.singleBasicInfo = {};
        this.singleBasicInfo["name"] = this.candidateData.name;
        this.singleBasicInfo["evalDate"] =
          this.singleFeedbackData.feedBackForm.createdAt;
        this.singleBasicInfo["panel"] =
          this.singleFeedbackData.feedBackForm.panelName;
        this.singleBasicInfo["modeOfInterview"] =
          this.singleFeedbackData.interviewRound.type;
        this.singleBasicInfo["action"] =
          this.singleFeedbackData.feedBackForm.recommendation;
        this.singleBasicInfo["remarks"] =
          this.singleFeedbackData.feedBackForm.recruiterRemarks;
        this.singleBasicInfo["feedback"] =
          this.singleFeedbackData.assessmentResponse;
      }
    },
    getRoundImage(round) {
      if (round.type == "f2f" && round.completed == false) {
        return require("../../../assets/talentpool/greyf2f.svg");
      } else if (round.type == "f2f" && round.completed == true) {
        return require("../../../assets/talentpool/face2face.svg");
      } else if (round.type == "assesment" && round.completed == false) {
        return require("../../../assets/talentpool/gray-assessment.svg");
      } else {
        return require("../../../assets/talentpool/face2face.svg");
      }
    },
    async getCandidateStatusDetails() {
      try {
        let payload = {
          candidateID: this.candidateID,
          jobID: this.$route.query.jobID,
        };
        const res = await getcandidateVendorJd(payload);
        if (res.status == 200) {
          this.candidateStatus = res.data.data;
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
.vend-applied-font {
  color: #3a3c40;
  font-size: 10.665px;
  font-weight: 600;
}

.vend-applied-date-font {
  color: #7a7a7a;
  font-size: 9.903px;
  font-weight: 500;
  margin-left: -6px;
}

.vend-onHold-font {
  color: #ffc145;
  font-size: 10.665px;
  font-weight: 600;
}

.vend-rejected-font {
  color: #eb0002;
  font-size: 10.665px;
  font-weight: 600;
}

.vend-notInterested-font {
  color: #424273;
  font-size: 10.665px;
  font-weight: 600;
}

.vend-selected-font {
  color: #038e00;
  font-size: 10.665px;
  font-weight: 600;
}

.width-122 {
  width: 122px;
}

.width-110 {
  width: 110px;
}

.vkcanddetails-tab-line-inactive {
  width: 118px;
  height: 1.33px;
  background: #a4a4a4;
}

.div-line {
  width: 1px;
  background-color: #dee2e6;
  height: 27px;
}
</style>
